<template>
  <b-card class="no-border mt-3" no-body>
    <company-table
      type="CUSTOMER"
      detail-url="/shipment_md/customers/"
      label="customer"
      />
  </b-card>
</template>
<script>
import CompanyTable from '@/components/CompanyTable.vue';

export default {
  components: { CompanyTable },
  name: 'customer_list',
  created() {
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'shipment_md', name: 'Shipment MD' },
      { to: 'customers', name: 'Customers' },
    ]);
  },
};
</script>


// WEBPACK FOOTER //
// src/views/pages/shipment_md/customers/List.vue